import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import momentPlugin from '@fullcalendar/moment'

import { Calendar } from "@fullcalendar/core";
import { Draggable } from "@fullcalendar/interaction";

import fr from "@fullcalendar/core/locales/fr";
import { ref } from "@vue/reactivity";
import { computed, watch } from "@vue/runtime-core";
import { useStore } from 'vuex'

import engine from "../core/index";
import moment from 'moment';
import timeGridPlugin from '@fullcalendar/timegrid';
import { onMounted } from "vue";
import listPlugin from '@fullcalendar/list';

export default function calendarData(handleEventClick,
    handleEventDrop,
    handleEventDragTime,
    handleEventReceive,
    getTechToShow,
    setAgency,
    getAgency,
    fullView,
    windowSize,
    selectedSize
) {
    const store = useStore()

    const nbrDaysdurationListe = ref([1, 2, 3, 5, 7, 15, 30, 90]);
    const slotdurationListe = ref(["00:30", "01:00", "02:00", "06:00", "12:00"]);
    const startPlanningTime = ref(["00:00", "02:00", "04:00", "06:00", "08:00", "10:00"]);
    const endPlanningTime = ref(["14:00", "16:00", "18:00", "20:00", "22:00", "23:59"]);
    const selectedNbrDays = ref(7)
    const selectedslotduration = ref("02:00")
    const selectedStartTime = ref("00:00")
    const selectedEndTime = ref("23:59")

    const eventColorById = ref({
        '100': { label: 'OR En attente', color: '#607D8B' },
        '110': { label: 'OR Planifié', color: '#FFA726' },
        '120': { label: 'OR Envoyer vers tablette', color: 'purple' },
        '130': { label: 'OR Récupéré', color: '#3F51B5' },
        '140': { label: 'Terminé', color: '#43A047' },
        'contrat-': { label: 'A Livrer', color: '#9FA8DA' },
        'contrat-Sortie': { label: 'A récupérer', color: '#EF5350' },
    })
    const eventColorByIdFiltered = ref({})
    const optionsPlanning = ref([])
    const statutToShow = ref([])
    const daysToHide = ref([]);
    const selectedPlanningVue = ref({});
    const isDataLoaded = ref(false)
    const isModalEventOpen = ref(false)
    const isModalSettingsOpen = ref(false)
    const selectedEvent = ref({});
    const eventsCalendar = ref([])
    const technicienList = ref([])
    const contratListeCalendarLiv = ref([])
    const contratListeCalendarRet = ref([])
    const eventsCalendarOld = ref([])
    const view = ref({ start: moment().format('MM/DD/YYYY'), end: moment().format('MM/DD/YYYY') })
    const eventsList = ref([]);
    const showFullContartData = ref(false);
    const isConnected = ref(true);
    const calendarDate = ref(moment().format('YYYY-MM-DD'))
    const selectedAgency = ref(undefined);
    const agencyList = ref(undefined);
    const selectedTechniciens = ref([]);
    const contratListe = ref([]);
    const contratListeToShow = ref([]);
    const contratListeToShowRet = ref([]);
    const contratListeToShowLiv = ref([]);
    const technicienListAvailable = ref([])
    const commentaireListe = ref([])
    const errorMessage = ref(undefined);
    const planningSettings = ref({});

    const calendarOptions = computed(function () {
        let option = {
            schedulerLicenseKey: '0359429366-fcs-1650894843',
            datesSet: updateCalendarView,
            nowIndicator: true,
            initialDate: calendarDate.value,
            plugins: [momentPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin, listPlugin],
            resourceAreaWidth: "120px",
            height: windowSize.height * (0.6 - selectedSize) + 'px',
            locale: fr,
            initialView: "defaultTimeLine",
            events: getFilteredEvents.value,
            eventClick: handleEventClick,
            eventDrop: handleEventDrop,
            eventResize: handleEventDragTime,
            hiddenDays: daysToHide.value,
            eventReceive: handleEventReceive,
            resourceAreaHeaderContent: 'Opérateur',
            resources: getFilteredTechnicien.value,
            titleFormat: { month: 'short', day: 'numeric' },
            views: {
                day: {
                    titleFormat: 'dddd D MMMM YYYY',
                },
                defaultTimeLine: {
                    type: 'resourceTimelineWeek',
                    duration: { days: selectedNbrDays.value },
                    slotDuration: selectedslotduration.value,
                    slotMinTime: selectedStartTime.value,
                    slotMaxTime: selectedEndTime.value,
                },
            },
            headerToolbar: {
                left: isRoot.value ? 'today prev parameter fullview' : 'today prev',
                center: 'title',
                right: 'next'
            },
            allDaySlot: false,
            editable: isRoot.value,
            droppable: true,
            buttonText: {
                today: 'AUJ'
            },
        };

        option['customButtons'] = {
            parameter: {
                text: 'Paramètre',
                click: openParametrage
            },
            fullview: {
                text: showFullContartData.value ? 'Groupé par contrat' : 'Affichage détaillé',
                click: function () {
                    showFullContartData.value = !showFullContartData.value
                }
            },
            refresh: {
                text: '⟳',
                click: refreshData
            },
        }

        return option;
    });

    const updatePlanningVue = function () {
        let newData = {
            selectedNbrDays: selectedNbrDays.value,
            selectedslotduration: selectedslotduration.value,
            selectedStartTime: selectedStartTime.value,
            selectedEndTime: selectedEndTime.value,
        }
        let token = localStorage.getItem("userToken");


        engine.update_planning_vue(newData, 'planning-technicien', token, function () {
        })

    }

    const openParametrage = function () {
        isModalSettingsOpen.value = true
    }

    const updateCalendarDaysToShow = function () {
        engine.get_day_to_hide(function (data) {
            if (data.code == 0) {
                daysToHide.value = data.data.data[0].fieldData.Value.split(',').map((val) => parseInt(val))
            }
        })
    }

    const updateCalendarColors = function () {
        engine.get_calendar_colors(function (data) {
            if (data.code == 0 && data.data.data[0].fieldData.Value != "" && data.data.data[0].fieldData.Value != undefined) {
                eventColorById.value = { ...eventColorById.value, ...JSON.parse(data.data.data[0].fieldData.Value) }
                refreshData()
            }
        })
    }

    const showErrorMessage = function (errorMessageValue, errorMessageValueLine2) {
        errorMessage.value = [errorMessageValue, errorMessageValueLine2];
        setTimeout(function () {
            errorMessage.value = undefined;
        }, 5000);
    };

    const initDraggbleEvents = function () {
        var containerEl = document.getElementById("external-events");
        var calendarEl = document.getElementById("calendar");
        new Draggable(containerEl, {
            itemSelector: ".fc-event",
            eventData: function (eventEl) {
                return {
                    title: eventEl.innerText,
                };
            },
        });

        new Calendar(calendarEl, {
            plugins: [dayGridPlugin, interactionPlugin, resourceTimelinePlugin],
            initialView: "resourceTimelineDay",
        });
    };

    const getContratListeToShow = function () {
        let date = {
            min: moment(view.value.start).format('x'),
            max: moment(view.value.end).format('x')
        }

        contratListe.value = []
        contratListeToShow.value = []

        engine.get_contrat_actif_ret(date, function (data) {
            contratListeToShowRet.value = []
            console.log("get_contrat_actif_ret", data);
            if (data.code == 0) {
                // contratListe.value = contratListe.value.concat(data.data.data.map((val) => val.fieldData))
                let contrat_to_ret = data.data.data.map((val) => val.fieldData)

                contrat_to_ret = [
                    ...new Map(contrat_to_ret.map((item) => [item.CLD_ID_CONTRAT_LOC_DATA, item])).values(),
                ];
                contratListeCalendarRet.value = contrat_to_ret
                contratListe.value = contratListe.value.concat(contrat_to_ret)

                for (let i = 0; i < contratListe.value.length; i++) {
                    let contratData = contratListe.value[i]
                    let chauffeurKey = "CLD_LIV_RETOUR_CHAUFFEUR"

                    let technicienTab = [
                        contratData[chauffeurKey + '(1)'],
                        contratData[chauffeurKey + '(2)'],
                        contratData[chauffeurKey + '(3)'],
                        contratData[chauffeurKey + '(4)'],
                        contratData[chauffeurKey + '(5)']
                    ].filter((val) => val != null && val != "")

                    technicienTab = technicienTab.filter(function (ele, pos) {
                        return technicienTab.indexOf(ele) == pos;
                    })

                    if (technicienTab.length == 0) {
                        let defaultTech = undefined
                        if (technicienList.value && technicienList.value.length > 0)
                            defaultTech = technicienList.value.find((val) => val.default == 'true')
                        if (defaultTech) {
                            contratData['CLD_LIV_RETOUR_CHAUFFEUR(1)'] = defaultTech.title
                            contratListe.value[i]['CLD_LIV_RETOUR_CHAUFFEUR(1)'] = defaultTech.title
                            contratListeCalendarRet.value[i]['CLD_LIV_RETOUR_CHAUFFEUR(1)'] = defaultTech.title
                        } else {
                            contratListeToShow.value.push(contratData)
                            contratListeToShowRet.value.push(contratData)
                        }
                    }
                }
            }
        })
        engine.get_contrat_actif_liv(date, function (data) {
            contratListeToShowLiv.value = []
            console.log("get_contrat_actif_liv", data);
            if (data.code == 0) {
                let contrat_to_liv = data.data.data.map((val) => val.fieldData)

                contrat_to_liv = [
                    ...new Map(contrat_to_liv.map((item) => [item.CLD_ID_CONTRAT_LOC_DATA, item])).values(),
                ];

                contratListe.value = contratListe.value.concat(contrat_to_liv)
                contratListeCalendarLiv.value = contrat_to_liv

                for (let i = 0; i < contrat_to_liv.length; i++) {
                    let contratData = contrat_to_liv[i]
                    let chauffeurKey = "CLD_LIV_DEPART_CHAUFFEUR"

                    let technicienTab = [
                        contratData[chauffeurKey + '(1)'],
                        contratData[chauffeurKey + '(2)'],
                        contratData[chauffeurKey + '(3)'],
                        contratData[chauffeurKey + '(4)'],
                        contratData[chauffeurKey + '(5)']
                    ].filter((val) => val != null && val != "")

                    technicienTab = technicienTab.filter(function (ele, pos) {
                        return technicienTab.indexOf(ele) == pos;
                    })

                    if (technicienTab.length == 0) {
                        let defaultTech = undefined
                        if (technicienList.value && technicienList.value.length > 0)
                            defaultTech = technicienList.value.find((val) => val.default == 'true')

                        if (defaultTech) {
                            contratData['CLD_LIV_DEPART_CHAUFFEUR(1)'] = defaultTech.title
                            // contratListe.value[i]['CLD_LIV_DEPART_CHAUFFEUR(1)'] = defaultTech.title
                            contratListeCalendarLiv.value[i]['CLD_LIV_DEPART_CHAUFFEUR(1)'] = defaultTech.title
                        } else {
                            contratListeToShow.value.push(contratData)
                            contratListeToShowLiv.value.push(contratData)
                        }
                    }

                }
            }
            initSav()
        })
    }

    const initSav = function () {
        engine.get_events_liste(
            moment(view.value.start).set({ hours: 0, minutes: 0, seconde: 0 }).format('MM/DD/YYYY'),
            moment(view.value.end).set({ hours: 23, minutes: 59, seconde: 59 }).format('MM/DD/YYYY'),
            function (data) {
                console.log("get_events_liste", data);

                isDataLoaded.value = true
                let tmpEventsCalendar = []
                let tmpEventsList = []
                let technicienTab = []
                if (data.code == '0') {
                    let list = data.data.data
                    for (let i = 0; i < list.length; i++) {
                        technicienTab = [
                            list[i].fieldData['Techniciens_Nom(1)'],
                            list[i].fieldData['Techniciens_Nom(2)'],
                            list[i].fieldData['Techniciens_Nom(3)'],
                            list[i].fieldData['Techniciens_Nom(4)'],
                            list[i].fieldData['Techniciens_Nom(5)']
                        ].filter((val) => val != null && val != "")
                        technicienTab = technicienTab.filter(function (ele, pos) {
                            return technicienTab.indexOf(ele) == pos;
                        })
                        let event = {
                            id: list[i].fieldData.id,
                            adliv: list[i].fieldData.adliv,
                            'N° RAP COMP': list[i].fieldData['N° RAP COMP'],
                            'Theme devis': list[i].fieldData['Theme devis'],
                            '_LINK MOTEUR': list[i].fieldData['_LINK MOTEUR'],
                            'Statut': list[i].fieldData['Statut'],
                            'societeliv': list[i].fieldData['societeliv'],
                            'villeliv': list[i].fieldData['villeliv'],
                            'Telephone': list[i].fieldData['Telephone'],
                            'Debut': moment(list[i].fieldData['Debut']).format(),
                            'Fin': moment(list[i].fieldData['Fin']).format(),
                            'Technicien': technicienTab,
                            'compadliv': list[i].fieldData['compadliv'],
                            'TYPE MACHINE': list[i].fieldData['TYPE MACHINE'],
                            'N° serie constr.': list[i].fieldData['N° serie constr.'],
                            'MARQUE MACHINE': list[i].fieldData['MARQUE MACHINE'],
                            'N° MATR INT': list[i].fieldData['N° MATR INT'],
                            'ID_Agence': list[i].fieldData['ID_Agence'],
                            'Message_Interne': list[i].fieldData['Message_Interne'],
                        }
                        if (list[i].fieldData['Statut'] !== '140') {
                            if (list[i].fieldData['Statut'] == '100' || list[i].fieldData['Statut'] == undefined || (list[i].fieldData['Debut'] == '' || list[i].fieldData['Fin'] == '')) {
                                tmpEventsList.push(event)
                            } else if (list[i].fieldData['Statut'] != '100') {
                                let title = ""
                                // title = list[i].fieldData['N° RAP COMP'] + ' ' + list[i].fieldData['villeliv'] + ' ' + list[i].fieldData['adliv'] + ' ' + list[i].fieldData['Theme devis']
                                if (list[i].fieldData['societeliv']) title += list[i].fieldData['societeliv'] + ' : '
                                if (list[i].fieldData['Theme devis']) title += list[i].fieldData['Theme devis']
                                tmpEventsCalendar.push({
                                    title: (fullView.value == false ? technicienTab + ' - ' : '') + title,
                                    resourceIds: technicienTab,
                                    start: moment(list[i].fieldData['Debut']).format(),
                                    end: moment(list[i].fieldData['Fin']).format(),
                                    event: event,
                                    color: eventColorById.value[list[i].fieldData['Statut']].color,
                                })
                            }
                        }
                    }
                }

                for (let i = 0; i < contratListeCalendarLiv.value.length; i++) {
                    let contratData = contratListeCalendarLiv.value[i]
                    let title = ""

                    title = contratData.CLD_CLIENT_RAISON_SOCIALE

                    let event = {
                        title: (fullView.value == false ? technicienTab + ' - ' : '') + title,
                        // resourceIds: technicienTab,
                        event: contratData,
                        contrat: contratData['CLD_NUM_CONTRAT'],
                    }

                    let tmpEventSortie = JSON.parse(JSON.stringify(event))

                    tmpEventSortie['end'] = moment(contratData.CLD_DATE_DEPART_TIMESTAMP).format()
                    tmpEventSortie['start'] = moment(contratData.CLD_DATE_LIVRAISON_DEPART).format()
                    tmpEventSortie['color'] = eventColorById.value['contrat-'].color

                    let technicienTabSortie = [
                        contratData['CLD_LIV_DEPART_CHAUFFEUR(1)'],
                        contratData['CLD_LIV_DEPART_CHAUFFEUR(2)'],
                        contratData['CLD_LIV_DEPART_CHAUFFEUR(3)'],
                        contratData['CLD_LIV_DEPART_CHAUFFEUR(4)'],
                        contratData['CLD_LIV_DEPART_CHAUFFEUR(5)']
                    ].filter((val) => val != null && val != "")

                    technicienTabSortie = technicienTabSortie.filter(function (ele, pos) {
                        return technicienTabSortie.indexOf(ele) == pos;
                    })

                    tmpEventSortie['resourceIds'] = technicienTabSortie
                    if (tmpEventSortie['resourceIds'].length > 0) {
                        tmpEventsCalendar.push(tmpEventSortie)
                    }
                }
                for (let i = 0; i < contratListeCalendarRet.value.length; i++) {
                    let contratData = contratListeCalendarRet.value[i]
                    let title = ""

                    title = contratData.CLD_CLIENT_RAISON_SOCIALE

                    let event = {
                        title: (fullView.value == false ? technicienTab + ' - ' : '') + title,
                        event: contratData,
                        contrat: contratData['CLD_NUM_CONTRAT'],
                    }

                    let tmpEventRet = JSON.parse(JSON.stringify(event))

                    tmpEventRet['start'] = moment(contratData.CLD_DATE_RETOUR_TIMESTAMP).format()
                    tmpEventRet['end'] = moment(contratData.CLD_DATE_LIVRAISON_RETOUR).format()
                    tmpEventRet['color'] = eventColorById.value['contrat-Sortie'].color

                    let technicienTabRet = [
                        contratData['CLD_LIV_RETOUR_CHAUFFEUR(1)'],
                        contratData['CLD_LIV_RETOUR_CHAUFFEUR(2)'],
                        contratData['CLD_LIV_RETOUR_CHAUFFEUR(3)'],
                        contratData['CLD_LIV_RETOUR_CHAUFFEUR(4)'],
                        contratData['CLD_LIV_RETOUR_CHAUFFEUR(5)']
                    ].filter((val) => val != null && val != "")

                    technicienTabRet = technicienTabRet.filter(function (ele, pos) {
                        return technicienTabRet.indexOf(ele) == pos;
                    })

                    tmpEventRet['resourceIds'] = technicienTabRet
                    if (tmpEventRet['resourceIds'].length > 0) {
                        tmpEventsCalendar.push(tmpEventRet)
                    }
                }
                console.log("tmpEventsCalendar", tmpEventsCalendar);

                eventsList.value = tmpEventsList
                eventsCalendar.value = tmpEventsCalendar
            })
        initOldEvents()
    }


    const initEvents = function () {
        getContratListeToShow()
    };

    const initOldEvents = function () {
        engine.get_old_events_liste(
            moment(view.value.start).format('MM/DD/YYYY'),
            moment(view.value.end).format('MM/DD/YYYY'),
            function (data) {
                isDataLoaded.value = true
                if (data.code == '0') {
                    let list = data.data.data
                    let tmpEventsCalendarOld = []
                    for (let i = 0; i < list.length; i++) {
                        let start = undefined
                        let end = undefined

                        if (list[i].fieldData['DATE RAPPORT'] && list[i].fieldData['DATE RAPPORT'].length != 0) {
                            start = list[i].fieldData['DATE RAPPORT'] + ' ' + list[i].fieldData['Heure Arriv(1)']
                            end = list[i].fieldData['DATE RAPPORT'] + ' ' + list[i].fieldData['Heure dep(1)']
                        } else {
                            start = list[i].fieldData['Debut']
                            end = list[i].fieldData['Fin']
                        }

                        let event = {
                            id: list[i].fieldData.id,
                            adliv: list[i].fieldData.adliv,
                            'N° RAP COMP': list[i].fieldData['N° RAP COMP'],
                            'Theme devis': list[i].fieldData['Theme devis'],
                            '_LINK MOTEUR': list[i].fieldData['_LINK MOTEUR'],
                            'Statut': '140',
                            'societeliv': list[i].fieldData['societeliv'],
                            'villeliv': list[i].fieldData['villeliv'],
                            'Telephone': list[i].fieldData['Telephone'],
                            'Debut': start,
                            'Fin': end,
                            'Technicien': list[i].fieldData['Techniciens_Nom(1)'],
                            'compadliv': list[i].fieldData['compadliv'],
                            'TYPE MACHINE': list[i].fieldData['TYPE MACHINE'],
                            'N° serie constr.': list[i].fieldData['N° serie constr.'],
                            'MARQUE MACHINE': list[i].fieldData['MARQUE MACHINE'],
                            'N° MATR INT': list[i].fieldData['N° MATR INT'],
                            'ID_Agence': list[i].fieldData['ID_Agence'],
                            'Message_Interne': list[i].fieldData['Message_Interne'],
                        }
                        let title = ""
                        if (list[i].fieldData['societeliv']) title += list[i].fieldData['societeliv'] + ' : '
                        if (list[i].fieldData['Theme devis']) title += list[i].fieldData['Theme devis']

                        tmpEventsCalendarOld.push({
                            resourceIds: [list[i].fieldData['Techniciens_Nom(1)']],
                            title: (fullView.value == false ? list[i].fieldData['Techniciens_Nom(1)'] + ' - ' : '') + title,
                            start: moment(start).format(),
                            end: moment(end).format(),
                            event: event,
                            color: eventColorById.value[140].color,
                        })
                    }
                    eventsCalendarOld.value = tmpEventsCalendarOld
                }
            })
    };

    const refreshData = function () {
        updateCalendarView()
        setTechnicienAvailable()
    }

    const updateCalendarView = function (calendarView) {
        if (calendarView == undefined) {
            initEvents()
        }
        if (calendarView != undefined && (view.value.start !== calendarView.startStr || view.value.end !== calendarView.endStr)) {
            view.value.start = calendarView.startStr
            view.value.end = calendarView.endStr
            initEvents()
        }
        goToSpecialDay()
    }

    const goToSpecialDay = function () {
        let day = moment(calendarDate.value).format('ddd')
        let elem = document.getElementsByClassName("fc-day-" + day.toLocaleLowerCase());
        if (elem[0]) elem[0].scrollIntoView({ inline: "center" });
    }

    const isTechnicienAvailable = function (e, event, techList) {
        let techNotAvailable = [];
        for (let a = 0; a < techList.length; a++) {
            let technicienListAvailableSelected =
                technicienListAvailable.value.filter(
                    (val) => val.TECHNICIEN === techList[a]
                );
            for (let i = 0; i < technicienListAvailableSelected.length; i++) {
                if (
                    moment(e.event.start).isBetween(
                        moment(technicienListAvailableSelected[i].start),
                        moment(technicienListAvailableSelected[i].end)
                    ) ||
                    moment(e.event.end).isBetween(
                        moment(technicienListAvailableSelected[i].start),
                        moment(technicienListAvailableSelected[i].end)
                    )
                ) {
                    techNotAvailable.push(techList[a]);
                }
            }
        }
        if (techNotAvailable.length != 0) {
            showErrorMessage(
                "ERREUR : Intervention " +
                selectedEvent.value["N° RAP COMP"] +
                " technicien(s) non disponible : " + techNotAvailable.join(' - ') + ""
            );
            e.revert();
            return false;
        }
        return true;
    };

    const getPlanningTechSettings = function () {
        engine.get_calendar_settings(function (data) {
            if (data.code == 0) {
                let planningSettingsTab = data.data.data.map((val) => ({ 'Name': val.fieldData.Name, 'Params': val.fieldData.Params == 1 ? true : false }))
                for (let i = 0; i < planningSettingsTab.length; i++) {
                    planningSettings.value[planningSettingsTab[i].Name] = planningSettingsTab[i].Params
                }
            }
        })
    }

    const arrayAreTheSame = function (arr1, arr2) {
        if (arr1.length != arr2.length)
            return false
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] != arr2[i])
                return false
        }
        return true
    }
    const cancelDriver = function () {
        let keyChauffeur = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? 'CLD_LIV_RETOUR_CHAUFFEUR' : 'CLD_LIV_DEPART_CHAUFFEUR'
        let keyState = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? 'CLD_LIVRAISON_RETOUR_STATE' : 'CLD_LIVRAISON_DEPART_STATE'

        let dataToUpdate = {}

        dataToUpdate[keyState] = ""

        for (let i = 0; i < 5; i++) {
            let key = keyChauffeur + '(' + (i + 1) + ')'
            dataToUpdate[key] = ""
        }

        engine.set_contrat(selectedEvent.value.CLD_NUM_CONTRAT, dataToUpdate, function () {
            refreshData()
        })
    }


    const editEventFromCalendar = function (newEvent, tech, refresh, isNewEvent) {
        if (selectedEvent.value.Statut != undefined) {
            let eventFileMakerFormat = {
                // 'Statut': selectedEvent.value.Statut <= 130 ? 110 : selectedEvent.value.Statut,
                'Statut': selectedEvent.value.Statut == 100 ? 110 : selectedEvent.value.Statut,
                'Debut': newEvent.event.startStr,
                'Fin': newEvent.event.endStr,
            }

            if (isNewEvent) {
                eventFileMakerFormat['Fin'] = moment(newEvent.event.startStr).add(selectedslotduration.value).format()
            }

            if (tech !== undefined) {
                if (isTechnicienAvailable(newEvent, false, tech)) {
                    if (newEvent.oldEvent == undefined || !arrayAreTheSame(newEvent.oldEvent._def.resourceIds, tech))
                        eventFileMakerFormat['Statut'] = "110"
                    else {
                        eventFileMakerFormat['Statut'] = newEvent.oldEvent._def.extendedProps.event.Statut
                    }
                    for (let i = 0; i < 5; i++) {
                        let key = 'Techniciens_Nom(' + (i + 1) + ')'
                        eventFileMakerFormat[key] = tech[i] == undefined ? "" : tech[i]
                    }
                } else {
                    return false
                }
            }
            if (eventFileMakerFormat.Fin === '')
                eventFileMakerFormat.Fin = moment(eventFileMakerFormat.Debut).add(2, 'h').format()

            eventFileMakerFormat.Debut = moment(eventFileMakerFormat.Debut).format('MM/DD/YYYY HH:mm:ss')
            eventFileMakerFormat.Fin = moment(eventFileMakerFormat.Fin).format('MM/DD/YYYY HH:mm:ss')

            engine.set_event(selectedEvent.value.id, eventFileMakerFormat, function () {
                if (refresh === true) {
                    refreshData()
                    calendarDate.value = moment(newEvent.event.start).format('YYYY-MM-DD')
                }
            })
        } else if (selectedEvent.value.CLD_ID_CONTRAT_LOC_DATA != undefined) {
            tech = newEvent.event._def.resourceIds
            let keyChauffeur = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? 'CLD_LIV_RETOUR_CHAUFFEUR' : 'CLD_LIV_DEPART_CHAUFFEUR'
            let keyState = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? 'CLD_LIVRAISON_RETOUR_STATE' : 'CLD_LIVRAISON_DEPART_STATE'
            let keyDate = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? 'CLD_DATE_LIVRAISON_RETOUR' : 'CLD_DATE_LIVRAISON_DEPART'
            let keyDateValue = selectedEvent.value.CLD_VISU_DEPART_RETOUR == "Sortie" ? parseInt(moment(newEvent.event.endStr).format('x')) : parseInt(moment(newEvent.event.startStr).format('x'))

            let dataToUpdate = {}

            dataToUpdate[keyState] = 1

            if (isNewEvent == false)
                dataToUpdate[keyDate] = keyDateValue

            if (tech !== undefined) {
                for (let i = 0; i < 5; i++) {
                    let key = keyChauffeur + '(' + (i + 1) + ')'
                    dataToUpdate[key] = tech[i] == undefined ? "" : tech[i]
                }
            }

            engine.set_contrat(selectedEvent.value.CLD_NUM_CONTRAT, dataToUpdate, function () {
                if (refresh === true) {
                    refreshData()
                    calendarDate.value = moment(newEvent.event.start).format('YYYY-MM-DD')
                }
            })
        }
    }

    // const setSelectedView = function (view) {
    //     selectedView.value = view
    //     verifRessourceListe()
    // }

    const getFilteredEvents = computed(function () {

        // let liste = commentaireListe.value.concat(technicienListAvailable.value.concat(eventsCalendarOld.value.concat(eventsCalendar.value)))

        let localEventsCalendar = eventsCalendar.value

        if (showFullContartData.value == false)
            localEventsCalendar = [
                ...new Map(eventsCalendar.value.map((item) => [`${item.contrat}-${item.color}`, item])).values(),
            ];


        let liste = commentaireListe.value.concat(technicienListAvailable.value.concat(eventsCalendarOld.value.concat(localEventsCalendar)))
        // let liste = localEventsCalendar

        return liste
    })

    const setEventColorByIdFiltered = function () {
        let liste = {}

        for (const [key, value] of Object.entries(eventColorById.value)) {
            if (statutToShow.value.includes(key)) {
                liste[key] = value
                liste[key]['key'] = key
            }
        }

        eventColorByIdFiltered.value = liste
    }

    const getFilteredTechnicien = computed(function () {
        let techList = technicienList.value.filter((val) => selectedTechniciens.value.includes(val.id)).sort((a,b) => a.position - b.position)
        
        if (selectedAgency.value == undefined)
            return techList
        else {
            return techList.filter((val) => val.ID_Agence == selectedAgency.value)
        }
    })

    const initTechnicienList = function () {
        engine.get_technicien_liste(function (data) {
            if (data.code == 0) {
                technicienList.value = data.data.data.map((val) => ({ id: val.fieldData.NOM_TECHNICIEN, title: val.fieldData.NOM_TECHNICIEN, ID_Agence: val.fieldData.ID_Agence, default: val.fieldData['DEFAULT'], position:val.fieldData['INDEX_TO_SHOW'] }))
                
                getTechToShow()
            }
            engine.get_agency_soft(function (data) {
                if (data.code === 0) {
                    agencyList.value = data.data.data.map((val) => ({
                        text: val.fieldData.ag_nom,
                        id: val.fieldData.ID_Agence,
                    }));
                }
                refreshData()
            });

        });
    }

    watch(selectedAgency, (val) => {
        setAgency(val)
    });

    const setCommentaires = function () {
        engine.get_commentaires_liste(function (data) {
            if (data.code == 0) {
                let dataFiltered = data.data.data.filter((val) => val.fieldData.state == 1)
                commentaireListe.value = dataFiltered.map((val) => ({
                    "Clé primaire": val.fieldData["Clé primaire"],
                    DEBUT: val.fieldData["DEBUT"],
                    FIN: val.fieldData["FIN"],
                    start: moment(val.fieldData["DEBUT"]).format(),
                    end: moment(val.fieldData["FIN"]).format(),
                    TECHNICIEN: val.fieldData["TECHNICIEN"],
                    resourceIds: [val.fieldData["TECHNICIEN"]],
                    display: 'background',
                    title: val.fieldData["COMMENTAIRE"],
                    backgroundColor: 'blue',
                }));
            }
        });
    };


    const setTechnicienAvailable = function () {
        engine.get_technicien_available_liste(function (data) {
            if (data.code == 0) {
                let dataFiltered = data.data.data.filter((val) => val.fieldData.state == 1)
                technicienListAvailable.value = dataFiltered.map((val) => ({
                    resourceIds: [val.fieldData["TECHNICIEN"]],
                    "Clé primaire": val.fieldData["Clé primaire"],
                    DEBUT: val.fieldData["DEBUT"],
                    FIN: val.fieldData["FIN"],
                    start: moment(val.fieldData["DEBUT"]).format(),
                    end: moment(val.fieldData["FIN"]).format(),
                    TYPE: val.fieldData["TYPE"],
                    TECHNICIEN: val.fieldData["TECHNICIEN"],
                    display: 'background',
                    title: val.fieldData["TYPE"],
                    backgroundColor: 'red',
                }));
            }
        });
    };

    const setPlanningVue = function () {
        let data = store.state.user.planning_display

        if (data && data.length > 0) {
            selectedPlanningVue.value = JSON.parse(data)
            if (selectedPlanningVue.value['planning-technicien']) {
                selectedNbrDays.value = selectedPlanningVue.value['planning-technicien'].selectedNbrDays
                selectedslotduration.value = selectedPlanningVue.value['planning-technicien'].selectedslotduration
                selectedStartTime.value = selectedPlanningVue.value['planning-technicien'].selectedStartTime
                selectedEndTime.value = selectedPlanningVue.value['planning-technicien'].selectedEndTime
            }
        } else {
            selectedPlanningVue.value = {}
        }
    }

    const getPlanningTechnicienOptions = function () {
        engine.get_planning_technicien_options(function (data) {
            if (data.code == 0) {
                optionsPlanning.value = data.data.data.map((val) => ({ 'key': val.fieldData.Key, 'value': val.fieldData.Value }))
                statutToShow.value = optionsPlanning.value.find((val) => val.key == "statutToShow")
                if (statutToShow.value && statutToShow.value.value)
                    statutToShow.value = statutToShow.value.value.split(',')
                else
                    statutToShow.value = []
            }
            setEventColorByIdFiltered()
        });
    };

    const isRoot = computed(function () {
        return store.state.user.admin == 1 ? true : false
    })

    onMounted(() => {
        updateCalendarColors()
        updateCalendarDaysToShow()
        initDraggbleEvents()
        initTechnicienList()
        getPlanningTechSettings()
        setTechnicienAvailable()
        setPlanningVue()
        setCommentaires()
        getAgency()
        getPlanningTechnicienOptions()
        selectedTechniciens.value = store.state.user.tech_to_show_planning_technicien.split(',')
    })

    return {
        eventsList,
        calendarOptions,
        selectedEvent,
        isModalEventOpen,
        eventsCalendar,
        editEventFromCalendar,
        isDataLoaded,
        eventColorById,
        initEvents,
        calendarDate,
        refreshData,
        isConnected,
        selectedAgency,
        agencyList,
        technicienList,
        selectedTechniciens,
        technicienListAvailable,
        setTechnicienAvailable,
        isTechnicienAvailable,
        showErrorMessage,
        errorMessage,
        planningSettings,
        isRoot,
        updateCalendarColors,
        updateCalendarDaysToShow,
        daysToHide,
        isModalSettingsOpen,
        commentaireListe,
        setCommentaires,
        statutToShow,
        eventColorByIdFiltered,
        optionsPlanning,
        // setSelectedView,
        // selectedView,
        nbrDaysdurationListe,
        slotdurationListe,
        startPlanningTime,
        endPlanningTime,
        selectedNbrDays,
        selectedslotduration,
        selectedStartTime,
        selectedEndTime,
        updatePlanningVue,
        contratListe,
        contratListeToShow,
        contratListeToShowLiv,
        contratListeToShowRet,
        cancelDriver
    };
}